import type { GetAcceptancesByParentRiskIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetAcceptancesByParentRiskIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAcceptancesByParentRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetAcceptancesByParentRiskIdArgs = {
  riskId: string;
};

export const useLazyGetAcceptancesByParentRiskId = createLazyQueryHook<
  UseLazyGetAcceptancesByParentRiskIdArgs,
  GetAcceptancesByParentRiskIdResponseRow[],
  GetAcceptancesByParentRiskIdQuery
>({
  trpcQuery: (client, { riskId }) =>
    client.frontend.acceptance.getByParentRiskId.query({ riskId }),
  mapTrpcDataToGraphQL: (data) => ({ acceptance: data }),
  graphqlDocument: GetAcceptancesByParentRiskIdDocument,
  graphqlVariables: ({ riskId }) => ({ ParentId: riskId }),
});
